export enum STEPS {
  WELCOME,
  REQUEST_QUOTE,
  CONFIRM_QUOTE,
  SUBMITTED,
}

export type RequestOtcQuoteFlowProps = {
  redirectToTrxHistory: () => void
  refreshTransaction: () => void
}

export type State = {
  step: STEPS
  sourceAmount: string
  destinationAmount: string
  sourceCurrency: CURRENCY | undefined
  destinationCurrency: CURRENCY | undefined
  redirectToTrxHistory: () => void
  refreshTransaction: () => void
}

export enum ACTIONS {
  SET_STEP = 'SET_STEP',
  SET_SOURCE_AMOUNT = 'SET_SOURCE_AMOUNT',
  SET_DESTINATION_AMOUNT = 'SET_DESTINATION_AMOUNT',
  SET_SOURCE_CURRENCY = 'SET_SOURCE_CURRENCY',
  SET_DESTINATION_CURRENCY = 'SET_DESTINATION_CURRENCY',
}

export type ActionTypes = {
  type: ACTIONS
  step: STEPS
  sourceAmount: string
  destinationAmount: string
  sourceCurrency: CURRENCY
  destinationCurrency: CURRENCY
}

export enum CURRENCY {
  XSGD = 'xsgd',
  XUSD = 'xusd',
  USDC = 'usdc',
  USDT = 'usdt',
  USDP = 'usdp',
  USD = 'usd',
  SGD = 'sgd',
}
